import { render } from "./Loader.vue?vue&type=template&id=89f24714"
const script = {}

import "./Loader.vue?vue&type=style&index=0&id=89f24714&lang=css"

import exportComponent from "C:\\Work\\Web-Widgets-FinanceJyskeFinans\\FinanceJyskeFinans.Web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__